import React from 'react';
import ReactTooltip from 'react-tooltip';
import { ReactSVG } from 'react-svg';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';
import activeStep1 from '../../../../assets/image/stages-steps/step1.svg';
import activeStep2 from '../../../../assets/image/stages-steps/step2.svg';
import activeStep3 from '../../../../assets/image/stages-steps/step3.svg';
import activeStep4 from '../../../../assets/image/stages-steps/step4.svg';
import activeStep5 from '../../../../assets/image/stages-steps/step5.svg';
import inactiveStep1 from '../../../../assets/image/stages-steps/grayStep1.svg';
import inactiveStep2 from '../../../../assets/image/stages-steps/grayStep2.svg';
import inactiveStep3 from '../../../../assets/image/stages-steps/grayStep3.svg';
import inactiveStep4 from '../../../../assets/image/stages-steps/grayStep4.svg';
import inactiveStep5 from '../../../../assets/image/stages-steps/grayStep5.svg';

const progressSteps = [
  {
    status: '',
    activeImg: activeStep1,
    inactiveImg: inactiveStep1,
    text: 'stageProgress.step1.title',
    hoverText: 'stageProgress.step1.description',
  },
  {
    status: '',
    activeImg: activeStep2,
    inactiveImg: inactiveStep2,
    text: 'stageProgress.step2.title',
    hoverText: 'stageProgress.step2.description',
  },
  {
    status: '',
    activeImg: activeStep3,
    inactiveImg: inactiveStep3,
    text: 'stageProgress.step3.title',
    hoverText: 'stageProgress.step3.description',
  },
  {
    status: '',
    activeImg: activeStep4,
    inactiveImg: inactiveStep4,
    text: 'stageProgress.step4.title',
    hoverText: 'stageProgress.step4.description',
  },
  {
    status: '',
    activeImg: activeStep5,
    inactiveImg: inactiveStep5,
    text: 'stageProgress.step5.title',
    hoverText: 'stageProgress.step5.description',
  },
];

const StepItem = ({ data, id }) => {
  const { text, hoverText, image, btnStyle, handleClick } = data;

  return (
    <div className="project__progress-item">
      <div className="project__tooltip-point">
        <i className="icon-info-alt" data-tip data-for={`stageProgress${id}`} />
      </div>
      <ReactTooltip
        className="project__tooltip"
        id={`stageProgress${id}`}
        place="top"
        backgroundColor="white"
        border
        borderColor="#d5d9e7"
        effect="solid"
      >
        <FormattedMessage id={hoverText} />
      </ReactTooltip>
      <div className="project__progress-info">
        <ReactSVG src={image} alt="Stage Progress" />
        <CustomBtn
          label={(
            <FormattedMessage
              id={text}
            />
          )}
          handleClick={handleClick}
          type="button"
          iconClass="icon-success"
          customClass={`project__progress-text ${btnStyle}`}
        />
      </div>
    </div>
  );
};

const StageProgress = ({ stageProgress, stageProgressHandler }) => {
  const translate = useIntl();

  const defineStepStatus = (currentStep) => {
    const stepsWithStatus = progressSteps.map((item, id) => {
      if (id < currentStep) {
        return {
          ...item,
          status: 'completed',
          image: item.activeImg,
          btnStyle: 'project__progress-completed',
          handleClick: () => {},
        };
      }
      if (id === currentStep) {
        return {
          ...item,
          status: 'current',
          image: item.activeImg,
          btnStyle: 'project__progress-current',
          handleClick: stageProgressHandler,
        };
      }
      return {
        ...item,
        status: 'inactive',
        image: item.inactiveImg,
        btnStyle: 'project__progress-inactive',
        handleClick: () => {},
      };
    });
    return stepsWithStatus;
  };

  return (
    <>
      <h2 className="project__progress-header">
        {translate.formatMessage({ id: 'stageProgress.title' })}
      </h2>
      <div className="project__progress-list">
        {defineStepStatus(stageProgress).map((item, id) => (
          <StepItem data={item} id={id} key={`ProgressStep${Date.now() + id}`} />
        ))}
      </div>
    </>
  );
};

export default StageProgress;
